import { yupResolver } from "@hookform/resolvers/yup";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableViewIcon from "@mui/icons-material/TableView";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import QueryError from "../../components/QueryError";
import Filters from "./filters/Filters";
import { useSinglePdfMutation } from "./generate-pdf/mutation/useSinglePdfMutation";
import { Logo } from "./Logo";
import { FilterModel } from "./models/FilterModel";

const schema = yup.object({
  addressPoint: yup
    .object()
    .required("Numer budynku jest wymagany. Wybierz go z listy")
    .typeError("Numer budynku jest wymagany. Wybierz go z listy"),
  street: yup
    .object()
    .required("Ulica jest wymagana. Wybierz ją z listy")
    .typeError("Ulica jest wymagana. Wybierz ją z listy"),
});

const TrashScheduleForm = () => {
  const importPdf = useSinglePdfMutation();
  const navigate = useNavigate();

  const methods = useForm<FilterModel>({
    defaultValues: {
      addressPoint: null,
      street: null,
    },
    resolver: yupResolver(schema),
  });

  const submitTable = (data: FilterModel) => {
    navigate(`/${data.addressPoint!.id}`);
  };
  const submitPdf = (data: FilterModel) =>
    importPdf.mutateAsync({ ...data.addressPoint! });
  return (
    <Box component="main">
      <FormProvider {...methods}>
        <Box
          component="form"
          sx={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            pb: 10,
          }}
        >
          <Stack spacing={5}>
            <Box sx={{ maxWidth: "250px" }}>
              <Logo />
            </Box>
            <Box>
              <Typography variant="h4" component="h1" sx={{ pb: 4 }}>
                Wygeneruj harmonogram wywozu śmieci
              </Typography>
              <Typography>
                Sprawdzenie harmonogramu wywozu odpadów należy zacząć od
                wskazania ulicy i numeru budynku.
              </Typography>
              <Typography>
                Dla wskazanego adresu można wyświetlić tabelę klikając "Pokaż
                harmonogram" lub pobrać gotowy do wydruku plik klikając w
                “Pobierz PDF".
              </Typography>
            </Box>
            <Box>
              <Filters />
            </Box>
            {importPdf.isError && (
              <Box>
                <QueryError
                  {...{
                    error: importPdf.error,
                    refetch: methods.handleSubmit(submitPdf),
                    unknownMessage:
                      "Nie udało się wygenerować pliku PDF z hamonogramem",

                    ariaUnknownMessage:
                      "Nie udało się wygenerować pliku PDF z hamonogramem; spróbuj ponownie, klikając w przycisk spróbuj ponownie",
                  }}
                />
              </Box>
            )}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                py: 3,
              }}
            >
              <Button
                variant="outlined"
                disabled={importPdf.isLoading}
                type="button"
                startIcon={
                  importPdf.isLoading ? (
                    <CircularProgress color="inherit" size="1rem" />
                  ) : undefined
                }
                onClick={methods.handleSubmit(submitPdf)}
                endIcon={<PictureAsPdfIcon />}
              >
                Pobierz PDF
              </Button>
              <Button
                type="button"
                onClick={methods.handleSubmit(submitTable)}
                endIcon={<TableViewIcon />}
              >
                Pokaż harmonogram
              </Button>
            </Box>
          </Stack>
        </Box>
      </FormProvider>
    </Box>
  );
};

export default TrashScheduleForm;
